/**
 * Secondi in schermata risultati (ENDED) prima del passaggio automatico a IDLE (gara non attiva).
 * Usato da `round-tick` e dal maxischermo per il passaggio automatico a IDLE.
 */
export const ENDED_TO_IDLE_SEC = 120;
export const ENDED_TO_IDLE_MS = ENDED_TO_IDLE_SEC * 1000;
